import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import extractText from 'flarum/common/utils/extractText';
import { MpNavHelper } from './MpNavHelper';
import DiscoverView from './DiscoverView';

/**
 * Loja: shell fino que monta a barra de navegação MP + o DiscoverView (que faz
 * todo o carregamento e a renderização — produtos, bundles, filtros, paginação).
 * O ShopPage não busca dados por si: delega ao DiscoverView para não duplicar
 * chamadas de API.
 */
export default class ShopPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'MarketplacePage App--index MarketplaceShopPage MpShop-body';
    app.setTitle(extractText(app.translator.trans('ramon-marketplace.forum.discover.title')));
  }
  view() {
    return m("div", null, MpNavHelper(), m(DiscoverView, null));
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/ShopPage', ShopPage);